module.exports = __webpack_public_path__ + "static/media/group-active.847bb4e5.svg";